import { createAction, props } from '@ngrx/store';

import { User } from '@lockton-apps/shared/interfaces';

import { UsersApiActions } from './actions.model';

export const loadUsersSuccess = createAction(
  UsersApiActions.LoadUsersSuccess,
  props<{ users: User[] }>()
);

export const loadUsersFailure = createAction(
  UsersApiActions.LoadUsersFailure,
  props<{ error: unknown }>()
);

export const loadBrokersByT2CodeSuccess = createAction(
  UsersApiActions.LoadBrokersByT2CodeSuccess,
  props<{ users: User[] }>()
);

export const loadBrokersByT2CodeFailure = createAction(
  UsersApiActions.LoadBrokersByT2CodeFailure,
  props<{ error: unknown }>()
);

export const loadClientBrokersSuccess = createAction(
  UsersApiActions.LoadClientBrokersSuccess,
  props<{ users: User[] }>()
);

export const loadClientBrokersFailure = createAction(
  UsersApiActions.LoadClientBrokersFailure,
  props<{ error: unknown }>()
);

export const loadAuthenticatedUserSuccess = createAction(
  UsersApiActions.LoadAuthenticatedUserSuccess,
  props<{ user: User }>()
);

export const loadAuthenticatedUserFailure = createAction(
  UsersApiActions.LoadAuthenticatedUserFailure,
  props<{ error: unknown }>()
);

export const loadUserSuccess = createAction(
  UsersApiActions.LoadUserSuccess,
  props<{ user: User }>()
);

export const loadUserFailure = createAction(
  UsersApiActions.LoadUserFailure,
  props<{ error: unknown }>()
);

export const addSuccess = createAction(
  UsersApiActions.AddSuccess,
  props<{ user: User }>()
);

export const addFailure = createAction(
  UsersApiActions.AddFailure,
  props<{ error: unknown }>()
);

export const updateSuccess = createAction(
  UsersApiActions.UpdateSuccess,
  props<{ user: User }>()
);

export const updateFailure = createAction(
  UsersApiActions.UpdateFailure,
  props<{ error: unknown }>()
);

export const addBrokerSuccess = createAction(
  UsersApiActions.AddBrokerSuccess,
  props<{ user: User }>()
);

export const addBrokerFailure = createAction(
  UsersApiActions.AddBrokerFailure,
  props<{ error: unknown }>()
);

export const updateBrokerSuccess = createAction(
  UsersApiActions.UpdateBrokerSuccess,
  props<{ user: User }>()
);

export const updateBrokerFailure = createAction(
  UsersApiActions.UpdateBrokerFailure,
  props<{ error: unknown }>()
);

export const userEnabledSuccess = createAction(
  UsersApiActions.UserEnabledSuccess,
  props<{ user: User }>()
);

export const userEnabledFailure = createAction(
  UsersApiActions.UserEnabledFailure,
  props<{ error: string }>()
);

export const userDeletedSuccess = createAction(
  UsersApiActions.UserDeletedSuccess,
  props<{ user: User }>()
);

export const userDeletedFailure = createAction(
  UsersApiActions.UserDeletedFailure,
  props<{ error: string }>()
);

export const updateLanguageSuccess = createAction(
  UsersApiActions.UpdateLanguageSuccess,
  props<{ user: User }>()
);

export const updateLanguageFailure = createAction(
  UsersApiActions.UpdateLanguageFailure,
  props<{ error: unknown }>()
);
